import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ExpandedTooltip, SimpleModal } from '@livable/saas-react-components';
import { Tab, Tabs } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import ActionsCell from './ActionsCell';
import useStyles from './styles';
const AttachBillFileModal = observer(props => {
  var _store$allocations$bi;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const dropComponent = props.dropComponent,
    dropFileUploaderCallback = props.dropFileUploaderCallback,
    propertyId = props.propertyId,
    utility = props.utility;
  const billFiles = (_store$allocations$bi = store.allocations.billFiles.get(propertyId)) === null || _store$allocations$bi === void 0 ? void 0 : _store$allocations$bi.filter(bill => bill.fileId && bill.utilityId === utility.utilityId);
  const isOpen = store.allocations.isAttachBillFileModalOpen.get(utility.utilityId);
  const _useState = useState('upload'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  const getFilesInfo = async data => {
    const resp = await store.files.getFilesInfoAsync.run(data);
    return resp;
  };
  const getPropertyBillsFileCabinet = async data => {
    const resp = await store.allocations.getPropertyBillsFileCabinetAsync.run(data);
    return resp;
  };
  useEffect(() => {
    if (propertyId && !billFiles) getPropertyBillsFileCabinet({
      propertyId
    }).then(response => {
      if (!response) return;
      const billsData = response.response || [];
      store.allocations.setBillFiles(propertyId, billsData);
      const fileIds = billsData.map(bill => bill.fileId).filter(Boolean);
      if ((fileIds === null || fileIds === void 0 ? void 0 : fileIds.length) > 0) return getFilesInfo({
        fileIds
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [utility.utilityId]);
  const handleClose = () => store.allocations.setIsAttachBillFileModalOpen(utility.utilityId, '');
  const handleTabChange = (e, newValue) => setSelectedTab(newValue);
  const renderCell = (parameter, left, longName) => /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft, " ").concat(longName && classes.cellLongName)
  }, longName ? /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: 'top',
    title: parameter,
    type: 'success-bold-dark'
  }, parameter) : parameter);
  const renderHeader = (text, right) => /*#__PURE__*/React.createElement("span", {
    className: right && classes.rightAlign
  }, text);
  const columns = [{
    align: 'right',
    field: 'fileName',
    flex: 1,
    minWidth: 300,
    renderCell: params => {
      var _store$files$fileData;
      return renderCell(params.row.fileId ? (_store$files$fileData = store.files.fileDataById.get(params.row.fileId)) === null || _store$files$fileData === void 0 ? void 0 : _store$files$fileData.fileName : 'N/A', true, true);
    },
    renderHeader: () => renderHeader('File \nName')
  }, {
    align: 'right',
    flex: 1,
    field: 'allocationName',
    maxWidth: 130,
    minWidth: 120,
    hideable: false,
    renderCell: params => renderCell(params.row.allocationName, true),
    renderHeader: () => renderHeader('Cycle'),
    sortComparator: (v1, v2) => {
      var _ref;
      return (_ref = '' + v1) === null || _ref === void 0 ? void 0 : _ref.localeCompare(v2, undefined, {
        numeric: true
      });
    }
  }, {
    align: 'right',
    flex: 1,
    field: 'actionsCell',
    maxWidth: 120,
    minWidth: 85,
    hideable: false,
    headerAlign: 'right',
    renderHeader: () => renderHeader('Actions'),
    renderCell: params => /*#__PURE__*/React.createElement(ActionsCell, {
      dropFileUploaderCallback: dropFileUploaderCallback,
      handleModalClose: handleClose,
      params: params
    })
  }];
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleClose,
    noPadding: true,
    isOpen: Boolean(isOpen),
    title: t('allocations.attach_file'),
    subTitle: isOpen,
    className: classes.modal,
    variant: "small"
  }, /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "tabs navigation",
    onChange: handleTabChange,
    type: "navigation",
    value: selectedTab
  }, /*#__PURE__*/React.createElement(Tab, {
    key: 'upload',
    label: t('allocations.upload_new_bill'),
    value: 'upload'
  }), /*#__PURE__*/React.createElement(Tab, {
    key: 'previous',
    label: t('allocations.use_previous_bills'),
    value: 'previous'
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, selectedTab === 'upload' ? /*#__PURE__*/React.createElement(React.Fragment, null, dropComponent) : /*#__PURE__*/React.createElement("div", {
    className: classes.previousBills
  }, /*#__PURE__*/React.createElement(DataGrid, {
    columns: columns,
    disableColumnMenu: true,
    disableRowSelectionOnClick: true,
    getRowId: row => row.fileId || "".concat(row.propertyId, "-").concat(row.utilityId),
    pagination: true,
    pageSize: 10,
    rowsPerPageOptions: [5, 10, 20],
    autoHeight: false,
    columnHeaderHeight: 80,
    rowHeight: 60,
    sx: {
      overflowX: 'scroll'
    },
    hideFooterSelectedRowCount: true,
    getRowClassName: () => classes.row,
    initialState: {
      pagination: {
        paginationModel: {
          pageSize: 25,
          page: 0
        }
      }
    },
    rows: billFiles
  }))));
});
export default AttachBillFileModal;